"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Configuration(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M4.927 4.927c3.903-3.903 10.24-3.903 14.142 0 3.904 3.904 3.904 10.24 0 14.143-3.903 3.903-10.239 3.903-14.142 0-3.903-3.903-3.903-10.24 0-14.143zM17.655 6.34c-3.119-3.118-8.195-3.118-11.314 0-2.368 2.37-2.935 5.863-1.704 8.776l1.55-1.55a5.985 5.985 0 0 1 1.547-5.79 6.02 6.02 0 0 1 6.753-1.21l1.301.595-.947 1.047-2.454 2.453a.67.67 0 1 0 .948.948l3.457-3.458.602 1.28c1.09 2.333.6 5.056-1.174 6.83a5.983 5.983 0 0 1-5.79 1.549L8.88 19.36c2.913 1.23 6.406.664 8.775-1.704 3.12-3.12 3.12-8.195 0-11.315zM12.19 8.03a4.006 4.006 0 0 0-3.04 1.16 4.012 4.012 0 0 0-1.162 2.574 3.982 3.982 0 0 0 .545 2.284l-2.856 2.857a8.343 8.343 0 0 0 1.414 1.414l2.856-2.856a3.976 3.976 0 0 0 2.285.544 3.996 3.996 0 0 0 3.74-4.208l-1.223 1.224a2.677 2.677 0 0 1-3.776 0 2.677 2.677 0 0 1 0-3.776z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Configuration;
